import { useEffect, useState } from 'react';
import { useApi } from '~/contexts';
import useIsMounted from './useIsMounted';

function browserTimeZoneName() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
}

export default function useTimeZoneName(timeZoneId) {
  const api = useApi();
  const isMounted = useIsMounted();

  const [name, setName] = useState(null);

  useEffect(() => {
    if (!timeZoneId) {
      setName(null);
      return;
    }

    (async () => {
      try {
        const { data } = await api.timeZones(timeZoneId).get();
        if (isMounted.current) setName(data?.name ?? null);
      } catch {
        if (isMounted.current) setName(null);
      }
    })();
  }, [api, timeZoneId, isMounted]);

  return name ?? browserTimeZoneName();
}
